import React, { useState } from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import { decodeAccount } from '../utils/utils';
import DialogForm from './DialogForm';

export default function GenerateAccountDialog({ open, onAdd, onClose }) {
  const [name, setName] = useState('');
  const [no_of_wallets, setNo_Of_Wallets] = useState('');

  const [isImport, setIsImport] = useState(false);
  const [importedPrivateKey, setPrivateKey] = useState('');

  const importedAccount = isImport
    ? decodeAccount(importedPrivateKey)
    : undefined;
//   const isAddEnabled = isImport ? name && importedAccount !== undefined : name;

  const isAddEnabled = name !== "" && no_of_wallets > 0



  // console.log("isAddEnabled",isAddEnabled);


  
 
  return (
    <DialogForm
      open={open}
      onEnter={() => {
        setName('');
        setIsImport(false);
        setPrivateKey('');
      }}
      onClose={onClose}
      onSubmit={() => onAdd({ name, no_of_wallets,importedAccount })}
      fullWidth
    >
      <DialogTitle>Generate Wallets</DialogTitle>
      <DialogContent style={{ paddingTop: 16 }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <TextField
            label="prefix"
            fullWidth
            variant="outlined"
            margin="normal"
            value={name}
            onChange={(e) => setName(e.target.value.trim())}
          />
          <TextField
            type='number'
            label="No_of_wallts"
            fullWidth
            variant="outlined"
            margin="normal"
            inputProps={{min:1}}
            value={no_of_wallets}
            onChange={(e) => setNo_Of_Wallets(e.target.value.trim())}
          />
         
          {/* <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  checked={isImport}
                  onChange={() => setIsImport(!isImport)}
                />
              }
              label="Import private key"
            />
          </FormGroup> */}
          {isImport && (
            <TextField
              label="Paste your private key here"
              fullWidth
              type="password"
              value={importedPrivateKey}
              variant="outlined"
              margin="normal"
              onChange={(e) => setPrivateKey(e.target.value.trim())}
            />
         )} 
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button type="submit" color="primary" disabled={!isAddEnabled}>
          Add
        </Button>
      </DialogActions>
    </DialogForm>
  );
}
